// extracted by mini-css-extract-plugin
export default {"modal":"SurveyModal_modal__j1Adp","survey_btn":"SurveyModal_survey_btn__TFTb0","close_btn":"SurveyModal_close_btn__zXilw"};